import React, { useState, useEffect } from "react";
import { Table, Button, Form, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useAuthProvider } from "../../customHooks/authContext";
import { useGet } from "../../customHooks/useGet";
import { put } from "../../services/Services";

const CoursesFormEditAddParticipants = ({ configId,schoolId, courseId, onHide, eventRegistrationId, courseDetails, fetchCourseData, setFetchCourseData }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [totalCost, setTotalCost] = useState(0);
  const [page, setPage] = useState(0);

  const { school, token } = useAuthProvider();
  console.log("el config recibido:", configId);
  console.log("el reg evento:", eventRegistrationId);
  console.log("el school recibido:", schoolId);
  

  useEffect(() => {
    if (courseDetails?.participants) {
      setSelectedMembers(courseDetails.participants.map(p => ({ member: { id: p.member.id } })));
    }
  }, [courseDetails]);

  const { data: membersData } = useGet(
    `https://ectech-software.com.ar/api/academy/schools/${schoolId}/members?page=${page}&size=10&order_by=surname&orientation=asc`,
    { headers: { Authorization: `Bearer ${token}` } }
  );

  const { data: courseData } = useGet(
    `https://ectech-software.com.ar/api/academy/events/${configId}/courses/${courseId}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );

  useEffect(() => {
    if (courseData) {
      setTotalCost(courseData.price * selectedMembers.length);
    }
  }, [selectedMembers, courseData]);

  const handleMemberChange = (e) => {
    const { value, checked } = e.target;
    const participantId = parseInt(value, 10);

    setSelectedMembers((prev) => {
      if (checked) {
        return prev.some((p) => p.member.id === participantId)
          ? prev
          : [...prev, { member: { id: participantId } }];
      } else {
        return prev.filter((p) => p.member.id !== participantId);
      }
    });
  };

  const handleSubmit = async () => {
    const payload = {
      course: { id: courseId },
      participants: selectedMembers,
      totalPrice: totalCost,
    };

    setLoading(true);
    try {
      await put(
        `/api/academy/events/registration/${eventRegistrationId}/courses/${courseDetails.id}`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSuccessMessage("Inscripción actualizada con éxito");
      setTimeout(() => {
        setSuccessMessage(null);
        setFetchCourseData(!fetchCourseData);
        onHide();
      }, 5000);
    } catch (error) {
      setError(error.response?.data?.message || "Error al actualizar la inscripción.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="shadow-lg p-4 w-100 mt-4">
      <Card.Header className="bg-warning text-white text-center">
        <h5 className="mb-0">Editar Inscripción - {courseData?.name} - Nivel {courseData?.level?.name}</h5>
      </Card.Header>
      <Card.Body>
        {membersData?.content?.length > 0 ? (
          <>
            <Table striped bordered hover className="text-center">
              <thead className="table-secondary">
                <tr>
                  <th>Seleccionar</th>
                  <th>Apellido</th>
                  <th>Nombre</th>
                </tr>
              </thead>
              <tbody>
                {membersData.content.map((member) => (
                  <tr key={member.id}>
                    <td>
                      <Form.Check
                        type="checkbox"
                        value={member.id}
                        checked={selectedMembers.some((p) => p.member.id === member.id)}
                        onChange={handleMemberChange}
                      />
                    </td>
                    <td>{member.surname}</td>
                    <td>{member.name}</td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <div className="d-flex justify-content-between align-items-center mt-3">
              <Button
                variant="outline-secondary"
                disabled={page === 0}
                onClick={() => setPage(prev => Math.max(prev - 1, 0))}
              >
                ← Anterior
              </Button>
              <span className="fw-bold">Página {page + 1}</span>
              <Button
                variant="outline-secondary"
                disabled={membersData.last} // Si tu backend no tiene `last`, reemplazalo por: membersData?.content.length < 10
                onClick={() => setPage(prev => prev + 1)}
              >
                Siguiente →
              </Button>
            </div>

            {selectedMembers.length > 0 && (
              <div className="mt-3">
                <h6 className="fw-bold">Participantes Seleccionados:</h6>
                <ul>
                  {selectedMembers.map((p, index) => {
                    const member = membersData.content.find(m => m.id === p.member.id);
                    return (
                      <li key={index}>
                        {member ? `${member.surname}, ${member.name}` : `ID ${p.member.id}`}
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
          </>
        ) : (
          <p>No hay miembros disponibles wey.</p>
        )}

        <div><h5>Costo Total: $ {totalCost}</h5></div>
        {error && <div className="alert alert-danger">{error}</div>}
        {successMessage && <div className="alert alert-success">{successMessage}</div>}
        <div className="mt-3 text-end">
          <Button variant="secondary" className="me-2" onClick={onHide}>Cancelar</Button>
          <Button variant="warning" onClick={handleSubmit} disabled={loading}>
            {loading ? 'Actualizando...' : 'Actualizar Inscripción'}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default CoursesFormEditAddParticipants;
